module.exports = __webpack_public_path__ + "static/img/1.e8575e1d.jpg";